module.exports = __webpack_public_path__ + "img/logo_hide_dark.3ae9587c.svg";